import './contact.component.scss'

const contactsList = document.querySelectorAll('.contact')
contactsList.forEach(section => {
  const contactImgWrapEl = section.querySelector('.contact__img')

  if (contactImgWrapEl) {
    const maskUrl = contactImgWrapEl.dataset.mask
    delete contactImgWrapEl.dataset.mask

    contactImgWrapEl.style.maskImage = `url(${maskUrl})`
    contactImgWrapEl.style.webkitMaskImage = `url(${maskUrl})`
  }
})


// сf7
const messageEl = document.querySelector('.wpcf7-response-output')

if (messageEl) {
	document.addEventListener('wpcf7submit', function () {
		messageEl.classList.add('active')
		setTimeout(() => {
			messageEl.classList.remove('active')
		}, 5000)
	})
}


// phone mask
const phoneInputs = document.querySelectorAll('input[type="tel"]');

function formatPhoneNumber(event) {
	const input = event.target;
	const inputValue = input.value.replace(/\D/g, '');
	const areaCode = inputValue.substring(0, 3);
	const centralOfficeCode = inputValue.substring(3, 6);
	const lineNumber = inputValue.substring(6, 10);

	let formattedValue = '';

	if (inputValue.length > 6) {
		formattedValue = `(${areaCode}) ${centralOfficeCode}-${lineNumber}`;
	} else if (inputValue.length > 3) {
		formattedValue = `(${areaCode}) ${centralOfficeCode}`;
	} else if (inputValue.length > 0) {
		formattedValue = `(${areaCode}`;
	}

	input.value = formattedValue;
}

if (phoneInputs.length > 0) {
	phoneInputs.forEach(input => {
		input.addEventListener('input', formatPhoneNumber)
	})
}

